<template>
  <div class="d-flex align-items-center justify-content-between">
    <div>
      <default-card-title-component
        :text="metric"
      ></default-card-title-component>
      <default-card-title-component
        :text="normalizedLabel"
        size-variation="medium"
      ></default-card-title-component>
      <p></p>
    </div>
    <div class="report__state-item-icon-container">
      <slot name="icon"></slot>
    </div>
  </div>
</template>
<script>
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
export default {
  components: {
    DefaultCardTitleComponent,
  },
  props: {
    metric: [Number, String],
    label: String,
  },
  computed: {
    normalizedLabel() {
      if (!this.label) return null;

      return this.label.toUpperCase();
    },
  },
};
</script>

<style>
.report__state-item-icon-container {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 8px;
}
</style>
